<template lang="pug">
  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle.d-none(:id="tblId")
    thead.thead-light
      tr
        th.text-center(width="5%")
          span #
        th(width="35%")
          span(:title="$t('ui.working_date')") {{ $t('ui.working_date') }}
        th.text-right(width="20%")
          span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
        th.text-right(width="20%")
          span(:title="$t('ui.actual_rebate')") {{ $t('ui.actual_rebate') }}
        th.text-right(width="20%")
          span(:title="$t('ui.rounded_rebate')") {{ $t('ui.rounded_rebate') }}
    tbody.clusterize-content
      tr(v-if="tbl.length == 0")
        td(:colspan="5").text-center
          span {{ $t('message.no_data_available') }}
      tr(v-for="(item, index) in tbl")
        td.text-center
          span(:title="index + 1") {{ index + 1 }}
        td
          span(:title="$moment(item.working_date).format('YYYY-MM-DD')") {{ $moment(item.working_date).format('YYYY-MM-DD') }}
        td.text-right
          span.font-weight-bold(:title="$n(item.turnover, 'currency')" :class="$helpers.fontClassName(item.turnover)") {{ item.turnover != null ? $n(item.turnover, 'currency') : null }}
        td.text-right
          span.font-weight-bold(:title="$n(item.actual_rebate, 'currency')" :class="$helpers.fontClassName(item.actual_rebate)") {{ item.actual_rebate != null ? $n(item.actual_rebate, 'currency') : null }}
        td.text-right
          span.font-weight-bold(:title="$n(item.rounded_rebate, 'currency')" :class="$helpers.fontClassName(item.rounded_rebate)") {{ item.rounded_rebate != null ? $n(item.rounded_rebate, 'currency') : null }}
      tr.footer
        td.text-right(colspan="2")
          span {{ $t("ui.sub_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnover)" :title="$n(subTotalTurnover, 'currency')") {{ $n(subTotalTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotalActualRebate)" :title="$n(subTotalActualRebate, 'currency')") {{ $n(subTotalActualRebate, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(subTotallRoundedRebate)" :title="$n(subTotallRoundedRebate, 'currency')") {{ $n(subTotallRoundedRebate, 'currency') }}
      tr.footer
        td.text-right(colspan="2")
          span {{ $t("ui.grand_total") }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotallActualRebate)" :title="$n(grandTotallActualRebate, 'currency')") {{ $n(grandTotallActualRebate, 'currency') }}
        td.text-right
          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalRoundedRebate)" :title="$n(grandTotalRoundedRebate, 'currency')") {{ $n(grandTotalRoundedRebate, 'currency') }}
</template>
<script>
export default {
  props: {
    tbl: {
      type: Array,
      default() {
        return []
      }
    },
    totalTbl: {
      type: Array,
      default() {
        return []
      }
    },
    tblId: {
      type: String,
      default: ""
    },
  },
  data: () => ({
    loading: false,
    subTotalTurnover: 0,
    grandTotalTurnover: 0,
    subTotalActualRebate: 0,
    grandTotallActualRebate: 0,
    subTotallRoundedRebate: 0,
    grandTotalRoundedRebate: 0,
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    accountID() {
      return this.$store.getters.accountId;
    },
  },
  watch: {
    tbl(newValue, oldValue) {
      this.getTotal();
    },
  },
  mounted: function() {
    this.getTotal();
  },
  methods: {
    clearTotal() {
      this.subTotalTurnover = 0
      this.grandTotalTurnover = 0
      this.subTotalActualRebate = 0
      this.grandTotallActualRebate = 0
      this.subTotallRoundedRebate = 0
      this.grandTotalRoundedRebate = 0
    },
    getTotal: function() {
      this.clearTotal();
      var tbl = this.tbl;
      if(tbl.length > 0) {
        tbl.forEach(value => {
          this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
          this.subTotalActualRebate = parseFloat(this.subTotalActualRebate) + parseFloat(value["actual_rebate"]);
          this.subTotallRoundedRebate = parseFloat(this.subTotallRoundedRebate) + parseFloat(value["rounded_rebate"]);
        });

        var totalTbl = this.totalTbl;
        if(totalTbl.length > 0) {
          this.grandTotalTurnover = totalTbl[0]["turnover"];
          this.grandTotallActualRebate = totalTbl[0]["actual_rebate"];
          this.grandTotalRoundedRebate = totalTbl[0]["rounded_rebate"];
        }
      }
    }
  }
};
</script>
